import { StateNode, TLPointerEventInfo } from "tldraw"

export class CustomNudgeIdle extends StateNode {
  static override id = "nudge-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("nudge", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
